<div class="container pt-2">
    <div class="row">
        <div class="col-md-12">
            <div class="row artists-con">
                <div class="col" *ngFor="let artist of artists">
                    <a [routerLink]="['/profile', artist?.id]">
                        <div style="width: 70%; margin: auto;">
                            <div class="artist-image">
                                <img src="https://ei.is.tuebingen.mpg.de/assets/noEmployeeImage_md-eaa7c21cc21b1943d77e51ab00a5ebe9.png" alt="Artist">
                            </div>
                        </div>
                        <div class="details text-center">
                            <h4 class="artist-name mb-0 font-weight-bold">{{ artist?.name }}</h4>
                            <p class="font-italic">{{ artist?.numberOfSongs }} songs</p>
                        </div>
                    </a>
                </div>
                
                
            </div>
        </div>
    </div>
</div>
